import { ShelterProfileComponent } from './shelter-profile.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IRouteConfigsOpts } from 'Src/ng2/routes/routes.config';
import { USER_ROLE_PERMISSIONS_FOR_GUARDS } from 'Src/ng2/routes/route-guards/user-role-permissions-for-route-guards.constant';
import { RouteGuards } from 'Src/ng2/routes/route-guards/route-guards';

const routes: IRouteConfigsOpts[] = [
  {
    path: '',
    component: ShelterProfileComponent,
    rolePermissions: USER_ROLE_PERMISSIONS_FOR_GUARDS['shelter/:shelterId/profile'],
    authenticationRequired: true,
    canActivate: [RouteGuards],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShelterProfileRoutingModule {}
